import { messaging } from "./fcmFirebase";
import { getToken } from "firebase/messaging";

export const generateFcmToken = async () => {
  try {
    const permission = await Notification.requestPermission();

    if (permission !== "granted") {
      console.log("Notification permission denied");
      return null;
    }

    const token = await getToken(messaging, {
      vapidKey: "BESiIy8N7Q_H8LnfYfdcOX6A-7y_8-TTVB6HPLfrCa4l9t6cW6haVitl0r7UQzurk-XO38NbjtI8OvpNj7LeR5E"
    });

    return token;

  } catch (error) {
    console.error("Error generating token:", error);
    return null;
  }
};
